import axios from 'axios';

const KEY="https://console.developers.google.com/projectselector2/apis/dashboard?pli=1&supportedpurview=project&project&folder&organizationId";

export default  axios.create({
    baseURL:'https://www.googleapis.com/youtube/v3',
  params:{
    part:'snippet',
    maxResults:5,
 key:KEY
 } 
 
 })

/*

function searchByKeyword() {
  var results = YouTube.Search.list('id,snippet', {q: 'dogs', maxResults: 25});

  for(var i in results.items) {
    var item = results.items[i];
    Logger.log('[%s] Title: %s', item.id.videoId, item.snippet.title);
  }
}

*/